import { LazyExoticComponent, Suspense } from 'react';
import { AppLoader } from '../components/Loader';
import ProtectRoute from './ProtectRoute';

/**
 * Usage:
 * element: LazyLoadElement(React.lazy(() => import('./components/MyComponent'))
 */
export function LazyLoadElement(LazyElement: LazyExoticComponent<any>) {
  // Wrapping around the suspense component is mandatory
  return (
    <Suspense fallback={<AppLoader.FlexLoader loaderHeight="h-screen" />}>
      <LazyElement />
    </Suspense>
  );
}

export function ProtectLazyLoadRoute(
  LazyElement: LazyExoticComponent<any>,
  /**
   * Placeholder for the chunk fetch. Pass the page's own loading state where
   * one exists, so the chunk wait and the data wait are one placeholder rather
   * than a full-screen spinner followed by a skeleton.
   */
  fallback: React.ReactNode = <AppLoader.FlexLoader loaderHeight="h-screen" />,
) {
  // Wrapping around the suspense component is mandatory
  return (
    <ProtectRoute>
      <Suspense fallback={fallback}>
        <LazyElement />
      </Suspense>
    </ProtectRoute>
  );
}
